export const usernameArray = [
    'Aspect',
    'Kraken',
    'Bender',
    'Lynch',
    'BigPapa',
    'MadDog',
    'Bowser',
    'ODoyle',
    'Bruise',
    'Psycho',
    'Cannon',
    'Ranger',
    'Clink',
    'Ratchet',
    'Cobra',
    'Reaper',
    'Colt',
    'Rigs',
    'Crank',
    'Ripley',
    'Creep',
    'Roadkill',
    'Daemon',
    'Ronin',
    'Decay',
    'Rubble',
    'Diablo',
    'Sasquatch',
    'Doom',
    'Scar',
    'Dracula',
    'Shiver',
    'Dragon',
    'Skinner',
    'Fender',
    'SkullCrusher',
    'Fester',
    'Slasher',
    'Fisheye',
    'Steelshot',
    'Flack',
    'Surge',
    'Gargoyle',
    'Sythe',
    'Grave',
    'Trip',
    'Gunner',
    'Trooper',
    'Hash',
    'Tweek',
    'Hashtag',
    'Vein',
    'Indominus',
    'Void',
    'Ironclad',
    'Wardon',
    'Killer',
    'Wraith',
    'Knuckles',
    'Zero',
    'Steel',
    'Kevlar',
    'Lightning',
    'Tito',
    'BulletProof',
    'FireBred',
    'Titanium',
    'Hurricane',
    'Ironsides',
    'IronCut',
    'Tempest',
    'IronHeart',
    'SteelForge',
    'Pursuit',
    'SteelFoil',
    'SickRebellious',
    'Upsurge',
    'Uprising',
    'Overthrow',
    'Breaker',
    'Sabotage',
    'Dissent',
    'Subversion',
    'Rebellion',
    'Insurgent',
    'AccidentalGenius',
    'AcidGosling',
    'AdmiralTot',
    'AgentHercules',
    'AirportHobo',
    'AlleyFrog',
    'Alpha',
    'AlphaReturns',
    'Angel',
    'AngelsCreed',
    'ArsenicCoo',
    'AtomicBlastoid',
    'AutomaticSlicer',
    'BabyBrown',
    'BackBett',
    'BadBunny',
    'BazookaHardehar',
    'BeardedAngler',
    'BeetleKing',
    'BettyCricket',
    'BitSentinel',
    'Bitmap',
    'BlacKitten',
    'Blister',
    'BlisteredOutlaw',
    'Blitz',
    'BloodEater',
    'Bonzai',
    'BoomBeachLuvr',
    'BoomBlaster',
    'BootlegTaximan',
    'Bowie',
    'Bowler',
    'Breadmaker',
    'Broomspun',
    'Buckshot',
    'BugBlitz',
    'BugFire',
    'Bugger',
    'Cabbie',
    'CandyButcher',
    'CapitalF',
    'CaptainPeroxide',
    'CelticCharger',
    'CenturionSherman',
    'CerealKiller',
    'ChasmFace',
    'ChewChew',
    'ChicagoBlackout',
    'Ballistic',
    'Furore',
    'Uproar',
    'Fury',
    'Ire',
    'Demented',
    'Wrath',
    'Madness',
    'Schizo',
    'Rage',
    'Savage',
    'Manic',
    'Frenzy',
    'Mania',
    'Derange',
    'CobraBite',
    'Cocktail',
    'CollaterolDamage',
    'CommandX',
    'Commando',
    'CongoWire',
    'CoolIris',
    'CoolWhip',
    'Cosmo',
    'CrashOverride',
    'CrashTest',
    'CrazyEights',
    'CrissCross',
    'CrossThread',
    'Cujo',
    'CupidDust',
    'DaffyGirl',
    'DahliaBumble',
    'DaisyCraft',
    'DancingMadman',
    'Dangle',
    'DanimalDaze',
    'DarkHorse',
    'DarksideOrbit',
    'DarlingPeacock',
    'DayHawk',
    'DesertHaze',
    'Desperado',
    'DevilBlade',
    'DevilChick',
    'Dexter',
    'DiamondGamer',
    'Digger',
    'DiscoPotato',
    'DiscoThunder',
    'DiscoMate',
    'DonStab',
    'DozKiller',
    'Dredd',
    'DriftDetector',
    'DriftManiac',
    'DropStone',
    'Dropkick',
    'DrugstoreCowboy',
    'DuckDuck',
    'EarlofArms',
    'EasySweep',
    'EerieMizzen',
    'ElactixNova',
    'ElderPogue',
    'ElectricPlayer',
    'ElectricSaturn',
    'EmberRope',
    'Esquire',
    'ExoticAlpha',
    'EyeShooter',
    'Fabulous',
    'FastDraw',
    'FastLane',
    'FatherAbbot',
    'FenderBoyXXX',
    'FennelDove',
    'FeralMayhem',
    'FiendOblivion',
    'FifthHarmony',
    'FireFeline',
    'FireFish',
    'FireByMisFire',
    'FistWizard',
    'Atilla',
    'Darko',
    'Terminator',
    'Conqueror',
    'MadMax',
    'Siddhartha',
    'Suleiman',
    'BillytheButcher',
    'Thor',
    'Napoleon',
    'Maximus',
    'Khan',
    'Geronimo',
    'Leon',
    'Leonidas',
    'Dutch',
    'Cyrus',
    'Hannibal',
    'Dux',
    'MrBlonde',
    'Agrippa',
    'JesseJames',
    'Matrix',
    'Bleed',
    'XSkull',
    'Gut',
    'Nail',
    'Jawbone',
    'Socket',
    'Fist',
    'Skeleton',
    'Footslam',
    'Tooth',
    'Craniax',
    'HeadKnocker',
    'Bone',
    'Razor',
    'Kneecap',
    'Cut',
    'Slaughter',
    'Soleus',
    'Gash',
    'Scalp',
    'Blood',
    'Scab',
    'Torque',
    'Torpedo',
    'Wildcat',
    'Automatic',
    'Cannon',
    'Hellcat',
    'Glock',
    'Mortar',
    'Tomcat',
    'Sniper',
    'Siege',
    'Panther',
    'Carbine',
    'Bullet',
    'Jaguar',
    'Javelin',
    'Aero',
    'Bomber',
    'Howitzer',
    'Albatross',
    'StrikeEagle',
    'Gatling',
    'Arsenal',
    'Rimfire',
    'Avenger',
    'Hornet',
    'Centerfire',
    'Hazzard',
    'Grizzly',
    'Wolverine',
    'Deathstalker',
    'Snake',
    'Wolf',
    'Scorpion',
    'Vulture',
    'Claw',
    'Boomslang',
    'Falcon',
    'Fang',
    'Viper',
    'Ram',
    'Grip',
    'Sting',
    'Boar',
    'BlackMamba',
    'Lash',
    'Tusk',
    'Goshawk',
    'Gnaw',
    'PolarBee',
    'PoppyCoffee',
    'PoptartAK',
    'Prometheus',
    'PsychoThinker',
    'Pusher',
    'RacyLion',
    'RadioactiveMan',
    'RaidBucker',
    'RandoTank',
    'Ranger',
    'RedCombat',
    'RedRhino',
    'RedFeet',
    'RedFisher',
    'RedMouth',
    'ReedLady',
    'RenegadeSlugger',
    'RenoMonarch',
    'Returns',
    'RevengeOfOmega',
    'RiffRaff',
    'Roadblock',
    'RoarSweetie',
    'RockyHighway',
    'RollerTurtle',
    'RomanceGuppy',
    'Rooster',
    'RudeSniper',
    'SaintLaZBoy',
    'Sandbox',
    'ScareStone',
    'ScaryNinja',
    'ScaryPumpkin',
    'Scrapper',
    'Scrapple',
    'Screw',
    'Screwtape',
    'SealSnake',
    'ShadowBishop',
    'ShadowChaser',
    'Sherwood',
    'Shooter',
    'ShowMeSunset',
    'ShowMeUrguts',
    'SidewalkEnforcer',
    'SiennaPrincess',
    'SilverStone',
    'SirShove',
    'SkullCrusher',
    'SkyBully',
    'SkyHerald',
]